/**
 * Usuarios, roles y grupos de supervisoras para la pantalla Solicitudes.
 * Usuarios y roles se leen una vez al abrir (son ~300 y cambian poco); los
 * grupos van en vivo, para que el cambio de disponibilidad de una compañera
 * se vea sin recargar.
 */

import { useEffect, useState } from 'react';
import { useFirebase } from 'react-redux-firebase';

const EMPTY = { loading: false, users: [], rolesById: {}, groups: [], error: null };

// enabled = false (supervisora de empresa): no lee nada y entrega el
// directorio vacío ya cargado. Las reglas no le dejan listar users, así que
// leerlo solo dejaba un aviso de error permanente en la pantalla.
export const useSupervisorDirectory = (enabled = true) => {
  const firebase = useFirebase();
  const [state, setState] = useState(enabled ? { ...EMPTY, loading: true } : EMPTY);

  useEffect(() => {
    if (!enabled) { setState(EMPTY); return undefined; }
    setState({ ...EMPTY, loading: true });
    const db = firebase.firestore();
    let alive = true;
    let base = { users: [], rolesById: {} };
    let baseDone = false;
    let groups = [];
    let groupsDone = false;
    let error = null;
    // Solo se da por cargado con las DOS partes: si se decidiera con los
    // usuarios y sin los grupos, el filtro arrancaría en "Todas" aunque ella
    // tenga grupo. Si falla leer usuarios, igual se muestran los grupos.
    const publish = () => {
      if (!alive) return;
      setState({ loading: !(baseDone && groupsDone), ...base, groups, error });
    };

    Promise.all([db.collection('users').get(), db.collection('roles').get()])
      .then(([u, r]) => {
        const rolesById = Object.fromEntries(r.docs.map((d) => [d.id, d.data()]));
        const users = u.docs.map((d) => {
          const x = d.data() || {};
          return { uid: d.id, email: x.Email || '', name: x['Nombre completo'] || x.Email || d.id, rolId: x.Rol?.id || null, alcance: x.Alcance || null };
        });
        base = { users, rolesById };
      })
      .catch((e) => { error = e || new Error('No se pudieron leer los usuarios'); })
      .finally(() => { baseDone = true; publish(); });

    const off = db.collection('supervisor_groups').onSnapshot(
      (s) => { groups = s.docs.map((d) => ({ uid: d.id, ...d.data() })); groupsDone = true; publish(); },
      (e) => { error = e; groupsDone = true; publish(); },
    );
    return () => { alive = false; off(); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return state;
};
